module.exports = __webpack_public_path__ + "static/media/arrows2.a55f13fe.svg";